__turbopack_context__.v({
  "breadcrumbs": "ProductsNav-module-scss-module__Qa4oaG__breadcrumbs",
  "grid": "ProductsNav-module-scss-module__Qa4oaG__grid",
  "isSearchStalled": "ProductsNav-module-scss-module__Qa4oaG__isSearchStalled",
  "noResults": "ProductsNav-module-scss-module__Qa4oaG__noResults",
  "products": "ProductsNav-module-scss-module__Qa4oaG__products",
  "root": "ProductsNav-module-scss-module__Qa4oaG__root",
  "search": "ProductsNav-module-scss-module__Qa4oaG__search",
  "searchButton": "ProductsNav-module-scss-module__Qa4oaG__searchButton",
  "showSearch": "ProductsNav-module-scss-module__Qa4oaG__showSearch",
});
